
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Select, Chip } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from "@mui/material";
//Actions
import {
    dashboardPanelShareRequest,
    dashboardPanelGetDashboardRequest,
    searchEntityRequest,
    clearRedux
} from 'Redux/actions';

//Styles
import './index.scss'

const ShareDashboard = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    const pmUsers = useSelector(state => state.generalRedux.pmUsers);
    const currentUser = useSelector(state => state.securityRedux.user);

    const [selectedUsers, setSelectedUsers] = useState([])
    const [user, setUser] = useState(null)

    //Redux States
    const {
        dashboard,
        openModal,
        loading,
        result,
        info,
    } = useSelector(state => state.shareDashboardRedux);

    const closeModal = () => {
        dispatch(clearRedux("DASHBOARD_PANEL_SHARE"))
    }

    const applyChanges = () => {
        let users = selectedUsers.length ? JSON.stringify(selectedUsers.map((item) => ({ id: `PM_${item.id}`, permission: item.permission }))) : null
        let payload = {
            id: dashboard.id,
            name: dashboard.name,
            sharedWith: users
        }
        dispatch(dashboardPanelShareRequest(payload))
    }

    let options = [{ id: "u", label: "Editor" }, { id: "r", label: "Lector" }]

    useEffect(() => {
        openModal && dispatch(searchEntityRequest({ key: "pmUsers" }));
        if (openModal && dashboard?.id) {
            dispatch(dashboardPanelGetDashboardRequest(dashboard.id))
        }
    }, [openModal, dashboard])

    useEffect(() => {
        if (info && pmUsers.length) {
            let sharedWith = info.sharedWith ? JSON.parse(info.sharedWith) : null
            if (sharedWith) {
                let currentUsers = sharedWith.map((item) => {
                    let id = item.id.replace(/^PM_/, "")
                    let user = pmUsers.find((pmusr) => pmusr.id === parseInt(id))
                    return {
                        ...item,
                        ...user
                    }
                })
                setSelectedUsers([...currentUsers])
            }
        }
    }, [info, pmUsers])

    useEffect(() => {
        if (result?.id) {
            NotificationManager.success(
                messages['menu_actions_share_success_message'],
                messages['menu_actions_share_dashboard'],
                3000,
            );
            closeModal();
        }
    }, [result])
    
    return (
        <Modal
            open={openModal}
            title={messages['menu_actions_share_dashboard']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div className="create-edit-dashboard-modal">
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="pm-users"
                                label={messages['users_tab_subuser']}
                                placeholder={messages['users_tab_subuser']}
                                options={pmUsers.length ? pmUsers.filter((item) => item?.id !== currentUser?.userId).map((item) => {
                                    return {
                                        ...item,
                                        fullName: `${item.firstName} ${item.lastName}`
                                    }
                                }) : []}
                                value={user}
                                textField="fullName"
                                valueField="id"
                                onChange={(items) => {
                                    setUser(items)
                                    let current = selectedUsers
                                    current.push({ ...items, permission: "r" })
                                    setSelectedUsers([...current])
                                    setUser(null)
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            {
                                selectedUsers.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={8}>
                                                    <Chip
                                                        label={`${item.firstName} ${item?.lastName}`}
                                                        handleDelete={() => {
                                                            let currentUsers = selectedUsers
                                                            let currentIndex = selectedUsers.findIndex(user => user.id === item?.id);
                                                            if (currentIndex !== -1) {
                                                                currentUsers.splice(currentIndex, 1);
                                                                setSelectedUsers([...currentUsers])
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className="permission-selector">
                                                        <Select
                                                            id="pm-users"
                                                            options={[{ id: "u", label: messages['menu_actions_editor'] }, { id: "r", label: messages['menu_actions_reader'] }]}
                                                            value={[{ id: "u", label: messages['menu_actions_editor'] }, { id: "r", label: messages['menu_actions_reader'] }].find((options) => options.id === item.permission)}
                                                            textField="label"
                                                            valueField="id"
                                                            onChange={(newItem) => {
                                                                let currentUsers = selectedUsers
                                                                let currentIndex = selectedUsers.findIndex(user => user.id === item?.id);
                                                                if (currentIndex !== -1) {
                                                                    currentUsers[currentIndex].permission = newItem.id
                                                                    setSelectedUsers([...currentUsers])
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef.current.submit()}
                >
                    {messages['menu_actions_share']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ShareDashboard;